import { shallowEqual, useSelector } from 'react-redux';
import {
	selectActiveSceneLinkedDesignSystemVersion,
	selectActiveSceneLatestDesignSystemVersion,
} from 'redux/db/reducers';
import { RootReducer } from 'redux/reducers';
import { DesignSystem } from 'dragonmouse-shared/interfaces';
import ActiveDesignSystemSection from '../ActiveDesignSystemSection';
import * as S from './styles';

interface ActiveDsPanelProps {
	onLinkDs: (designSystem: DesignSystem | null) => Promise<void>;
	onClose: () => void;
	onShowLinkPanel: () => void;
}

const ActiveDsPanel = ({ onLinkDs, onClose, onShowLinkPanel }: ActiveDsPanelProps) => {
	const { linkedVersion, latestVersion } = useSelector((r: RootReducer) => {
		return {
			linkedVersion: selectActiveSceneLinkedDesignSystemVersion(r.db),
			latestVersion: selectActiveSceneLatestDesignSystemVersion(r.db),
		};
	}, shallowEqual);

	// Calculate updatePendingState internally
	const updatePendingState: 'publishing' | 'ready' | null = (() => {
		if (!latestVersion) return null;
		const promptStatus = latestVersion.manifest?.promptGenerationStatus;
		if (promptStatus === 'pending' || promptStatus === 'generating') {
			return 'publishing';
		}
		if (
			linkedVersion &&
			latestVersion &&
			linkedVersion.versionNumber < latestVersion.versionNumber &&
			promptStatus === 'complete'
		) {
			return 'ready';
		}
		return null;
	})();

	const handleLinkNew = () => {
		onShowLinkPanel();
	};

	return (
		<>
			<ActiveDesignSystemSection
				onLinkDs={onLinkDs}
				onClose={onClose}
				updatePendingState={updatePendingState}
			/>
			<S.SectionDivider />
			<S.DropdownSection>
				<S.ChangeLink onClick={handleLinkNew}>
					<S.ChangeLinkText>Switch Design System</S.ChangeLinkText>
					<S.ChangeLinkArrow>→</S.ChangeLinkArrow>
				</S.ChangeLink>
			</S.DropdownSection>
		</>
	);
};

export default ActiveDsPanel;
